import { compressAccurately } from "image-conversion";
import { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { useDispatch } from "react-redux";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Modal } from "reactstrap";
import { checkAuth } from "../../../Utils/CheckAuthentication";
import { TOKEN_KEY } from "../../../Utils/Constants";
import DataURIToBlob from "../../../Utils/DataURIToBlob";
import { noBodyScroll } from "../../../Utils/NoScroll";
import { baseUrl } from "../../../shared/baseUrl";
import { createNotification } from "../../Common/CreateNotification";
import ReactRating from "../../Common/ReactRate/RateStars";
import CustomSelect from "../../Common/Select/CustomSelect";
import ImageCropper from "../ImageCropper";
import SelectImageModal from "../SelectImageModal";
import { toggleLoading } from "../../../Redux/reducers/loadingSlice";

const EditProductModal = ({
  onEdited,
  isOpen,
  onClose,
  product = null,
  cityOption,
  categoryOption,
  uploadedImages,
  productImages,
  isApproved = 0,
}) => {
  const dispatch = useDispatch();
  // const [isLoading, setIsLoading] = useState(false);
  // const [isFetchImageLoading, setIsFetchImageLoading] = useState(false);
  const isFetchImageLoading = false;
  const [images, setImages] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [imageSelectModal, setImageSelectModal] = useState(false);

  // For Product Upload
  const [selectedImages, setSelectedImages] = useState([]);
  const [productId, setProductId] = useState(undefined);
  const [productName, setProductName] = useState(undefined);
  const [productDescription, setProductDescription] = useState(undefined);
  const [productPrice, setProductPrice] = useState(undefined);
  const [productCondition, setProductCondition] = useState("");
  const [city, setCity] = useState(undefined);
  const [category, setCategory] = useState(undefined);
  const [purchaseDate, setPurchaseDate] = useState(undefined);
  const [gender, setGender] = useState(undefined);
  const [isRefundable, setIsRefundable] = useState(undefined);
  const [isExchangable, setIsExchangable] = useState(undefined);
  const [categoryName, setCategoryName] = useState(undefined);

  // Validation Texts
  const [nameText, setNameText] = useState("");
  const [descText, setDescText] = useState("");
  const [priceText, setPriceText] = useState("");
  const [conditionText, setConditionText] = useState("");
  const [cityText, setCityText] = useState("");
  const [categoryText, setCategoryText] = useState("");
  const [purchaseDateText, setPurchaseDateText] = useState("");
  const [selecedImagesText, setSelecedImagesText] = useState("");
  const animatedComponents = makeAnimated();

  useEffect(() => {
    uploadedImages && setImages(uploadedImages);
  }, [uploadedImages]);

  useEffect(() => {
    if (product !== null) {
      console.log(product.category_id);
      // setSelectedImages(Object.values(productImages));

      setSelectedImages(productImages.map((e) => Object.keys(e)[0]));
      console.log(productImages.map((e) => Object.keys(e)[0]));

      setProductId(product.id);
      setProductName(product.name);
      setProductDescription(product.desc);
      setProductPrice(product.price);
      setProductCondition(product.condition);
      setCity(parseInt(product.city_id));
      setCategory(product.category_id);
      setPurchaseDate(product.date_of_purchase);
      setGender(product.gender);
      setIsExchangable(product.is_exchangeable);
      setIsRefundable(product.is_refundable);
      setCategoryName(product.category_name);
    }
  }, [product, productImages]);

  useEffect(() => {
    noBodyScroll(isOpen);
    return () => {
      noBodyScroll(false);
    };
  }, [isOpen]);

  const apply = (file) => {
    dispatch(toggleLoading(true));
    compressAccurately(DataURIToBlob(file), 200).then((res) => {
      uploadImage(res);
    });
  };

  const uploadImage = async (file) => {
    setImageSelectModal(false);
    dispatch(toggleLoading(true));
    var formdata = new FormData();
    formdata.append("file", file);
    await fetch(baseUrl + "upload-image", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem(TOKEN_KEY)).token,
      },
      body: formdata,
    })
      .then((res) => checkAuth(res))
      .then((res) => {
        if (res.success) {
          createNotification("success", res.message);
          setImages((prevState) => [res.image, ...prevState]);
          dispatch(toggleLoading(false));
          console.log(res.image);
          console.log(images);
        } else {
          dispatch(toggleLoading(false));
          createNotification("error", res.message);
        }
      })
      .catch((e) => {
        dispatch(toggleLoading(false));
        createNotification("error", e.message);
      });
  };

  const reset = () => { };

  const resetValidationTexts = () => {
    setNameText("");
    setDescText("");
    setPriceText("");
    setCityText("");
    setCategoryText("");
    setPurchaseDateText("");
    setSelecedImagesText("");
  };

  const validateProduct = (e) => {
    e.preventDefault();

    resetValidationTexts();

    if (productName.length < 3) {
      setNameText("The product name must be at least 3 characters long");
      return false;
    } else if (productName.length > 100) {
      setNameText("The product name must be less than 100 characters long");
      return false;
    } else if (productDescription.length < 10) {
      setDescText(
        "The product description must be at least 10 characters long"
      );
      return false;
    } else if (productDescription.length > 5000) {
      setDescText(
        "The product description must be less than 5000 characters long"
      );
      return false;
    } else if (productPrice.length <= 0) {
      setPriceText("The product price field is required.");
      return false;
    } else if (productPrice.length > 0 && isNaN(productPrice)) {
      setPriceText("The product price must be numeric.");
      return false;
    } else if (productCondition.length <= 0) {
      setConditionText("The product condition is required.");
      return false;
    } else if (purchaseDate.length <= 0) {
      setPurchaseDateText("The purchase date field is required.");
      return false;
    } else if (purchaseDate.length <= 0) {
      setPurchaseDateText("The purchase date field is required.");
      return false;
    } else if (category === null) {
      setCategoryText("The category field is required.");
      return false;
    } else if (city.length === null) {
      setCityText("The city field is required.");
      return false;
    } else if (selectedImages.length <= 0) {
      setSelecedImagesText("Please select at least one image.");
      return false;
    } else {
      handleEditProduct();
    }
  };

  const handleEditProduct = async () => {
    dispatch(toggleLoading(true));
    var formdata = new FormData();
    formdata.append("product_id", productId);
    formdata.append("product_name", productName);
    formdata.append("product_description", productDescription);
    formdata.append("product_price", productPrice);
    formdata.append("product_city", city);
    formdata.append(
      "product_category",
      category === undefined ? product.category_id : category
    );
    formdata.append("date_of_purchase", purchaseDate);
    formdata.append("product_gender", gender);
    formdata.append("exchangeable", isExchangable);
    formdata.append("refundable", isRefundable);
    formdata.append("product_images", JSON.stringify(selectedImages));
    formdata.append("product_condition", productCondition);
    formdata.append("is_approved", isApproved);

    await fetch(baseUrl + "edit-product", {
      method: "POST",
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem(TOKEN_KEY)).token,
      },
      body: formdata,
    })
      .then((res) => checkAuth(res))
      .then((res) => {
        if (res.success) {
          dispatch(toggleLoading(false));
          createNotification("success", res.message);
          onEdited();
          onClose();
        } else {
          dispatch(toggleLoading(false));
          createNotification("error", res.message);
        }
      })
      .catch(() => {
        dispatch(toggleLoading(false));
        createNotification("error", "Failed to edit product");
      });
  };

  return (
    <div>
      <Modal
        id="edit-modal"
        size="xl"
        isOpen={isOpen}
        className="position-relative sc-modal"
        centered
      >
        <div
          onClick={() => {
            reset();
            onClose();
          }}
          className="position-absolute cursor-pointer"
          style={{ top: 6, right: 10 }}
        >
          <FaTimes size={20} />
        </div>
        <div className="px-3 py-3">
          <h4>Edit Product</h4>
          <p className="small">
            Please make changes to the requrie fields to edit your product.
          </p>
          <hr className="mb-3 mt-n3" style={{ color: "#a8a8a890" }} />
          <form className="row g-3" onSubmit={validateProduct}>
            <div className="col-md-6">
              <label htmlFor="inputText" className="form-label fw-bold">
                Name
              </label>
              <input
                value={productName}
                onChange={(e) => {
                  setProductName(e.target.value);
                }}
                required
                minLength="5"
                maxLength="100"
                type="text"
                className="form-control"
                id="inputText"
                placeholder="Name of your product"
              />
              <p className="text-danger small">{nameText}</p>
            </div>
            <div className="col-md-6">
              <label htmlFor="inputPrice" className="form-label fw-bold">
                Price
              </label>
              <input
                value={productPrice}
                onChange={(e) => {
                  setProductPrice(e.target.value);
                }}
                required
                type="number"
                className="form-control"
                id="inputPrice"
                placeholder="Price of your product"
              />
              <p className="text-danger small">{priceText}</p>
            </div>
            <div className="col-12">
              <div className="d-flex flex-wrap">
                <label htmlFor="inputPrice my-auto" className="fw-bold">
                  Product Condition
                </label>
                &nbsp;
                <span className="small my-auto">
                  (Specify the product condition range from 1 to 5.)
                </span>
              </div>
              <ReactRating
                isEnabled={true}
                rate={productCondition}
                onRate={(rate) => {
                  console.log(rate);
                  setProductCondition(rate);
                }}
              />
              <p className="text-danger small">{conditionText}</p>
            </div>
            <div className="col-12">
              <label className="form-label fw-bold">Description</label>
              <textarea
                value={productDescription}
                onChange={(e) => {
                  setProductDescription(e.target.value);
                }}
                required
                minLength="10"
                maxLength="5000"
                rows={5}
                className="form-control"
              ></textarea>
              <p className="text-danger small">{descText}</p>
            </div>
            <div className="col-md-6">
              <label className="form-label fw-bold">Category</label>
              {categoryOption && (
                <CustomSelect
                  catName={categoryName}
                  selectedCategory={(catId) => {
                    setCategory(catId);
                  }}
                  categories={categoryOption}
                  placeholder="Select Category"
                />
              )}
              <p className="text-danger small">{categoryText}</p>
            </div>
            <div className="col-md-6">
              <label className="form-label fw-bold">City</label>
              {cityOption && (
                <>
                  <Select
                    required
                    autoComplete={false}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    placeholder={"Select City"}
                    isMulti={false}
                    options={cityOption}
                    value={cityOption.find((e) => e.value === city)} // set selected values
                    onChange={(e) => {
                      if (e !== null) {
                        setCity(e.value);
                      }
                    }}
                  />
                  <p className="text-danger small">{cityText}</p>
                </>
              )}
            </div>
            <div className="col-md-6">
              <label className="form-label fw-bold">Purchase Date</label>
              <input
                required
                value={purchaseDate}
                onChange={(e) => {
                  setPurchaseDate(e.target.value);
                }}
                type="date"
                className="form-control"
                id="inputCity"
              />
              <p className="text-danger small">{purchaseDateText}</p>
            </div>
            <div className="col-md-6">
              <label className="form-label fw-bold">Gender</label>
              <select
                value={gender}
                onChange={(e) => {
                  setGender(e.target.value);
                }}
                required
                className="form-select"
              >
                <option value="f">Female</option>
                <option value="m">Male</option>
                <option value="b">Unisex</option>
              </select>
            </div>
            <div className="col-md-6">
              <label className="form-label fw-bold d-block">Is Refundable</label>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="editRefundable"
                  id="editRefundableYes"
                  value={1}
                  checked={Number(isRefundable) === 1}
                  onChange={(e) => {
                    setIsRefundable(e.target.value);
                  }}
                  required
                />
                <label className="form-check-label" htmlFor="editRefundableYes">
                  Yes
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="editRefundable"
                  id="editRefundableNo"
                  value={0}
                  checked={Number(isRefundable) === 0}
                  onChange={(e) => {
                    setIsRefundable(e.target.value);
                  }}
                  required
                />
                <label className="form-check-label" htmlFor="editRefundableNo">
                  No
                </label>
              </div>
            </div>
            <div className="col-md-6">
              <label className="form-label fw-bold d-block">Is Exchangable</label>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="editExchangable"
                  id="editExchangableYes"
                  value={1}
                  checked={Number(isExchangable) === 1}
                  onChange={(e) => {
                    setIsExchangable(e.target.value);
                  }}
                  required
                />
                <label className="form-check-label" htmlFor="editExchangableYes">
                  Yes
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="editExchangable"
                  id="editExchangableNo"
                  value={0}
                  checked={Number(isExchangable) === 0}
                  onChange={(e) => {
                    setIsExchangable(e.target.value);
                  }}
                  required
                />
                <label className="form-check-label" htmlFor="editExchangableNo">
                  No
                </label>
              </div>
            </div>
            <div className="col-12">
              <label className="form-label fw-bold">Select Images: </label>{" "}
              <button
                onClick={() => {
                  setUploadModal(true);
                }}
                type="button"
                className="btn btn-warning ms-2"
              >
                Choose Images
              </button>
              <span className="fw-bold small ms-4">
                {selectedImages.length > 0 &&
                  selectedImages.length + " images selected."}{" "}
              </span>
              <p className="text-danger small">{selecedImagesText}</p>
            </div>
            <div className="col-12">
              <button type="submit" className="btn btn-primary">
                Done
              </button>
            </div>
          </form>
        </div>
      </Modal>

      <SelectImageModal
        uploadModal={uploadModal}
        setUploadModal={setUploadModal}
        setImageSelectModal={setImageSelectModal}
        images={images}
        selectedImages={selectedImages}
        setSelectedImages={setSelectedImages}
        isFetchImageLoading={isFetchImageLoading}
      />

      <ImageCropper
        imageSelectModal={imageSelectModal}
        setImageSelectModal={setImageSelectModal}
        apply={apply}
      />
    </div>
  );
};

export default EditProductModal;
